module.exports = __webpack_public_path__ + "img/free06_800x400.cd98c683.jpg";